module.exports = __webpack_public_path__ + "img/s6_img.b0949e30.png";